import gql from 'graphql-tag';

import ProductDataFragment from './ProductData.js';

export default gql`
  fragment ProductTeaserListItemFragment on ProductTeaserListItem {
    id
    type
    data {
      titleHtml
      catalog {
        slug
        name
        id
      }
      products {
        ...ProductDataFragment
      }
    }
  }
  ${ProductDataFragment}
`;
